import { createSlice } from '@reduxjs/toolkit';
import { IGridFilterModel, IGridSortModel } from 'src/components';
import { ApiRequest } from 'src/models/api.request';
import MuracaatDetayliAramaRequest from 'src/models/HastaKayit/MuracaatDetayliAramaRequest';
import VwHastamuracaatDTO from 'src/models/HastaKayit/VwHastamuracaatDTO';
import VwHastamuracaatListeDTO from 'src/models/HastaKayit/VwHastamuracaatListeDTO';
import VwMuracaatAramaDTO from 'src/models/HastaKayit/VwMuracaatAramaDTO';
import VwHbsHastaservisDTO from 'src/models/HastaServis/VwHbsHastaservisDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { MuracaatApi } from 'src/services/HastaKayit/MuracaatApi';
import { helper } from 'src/utils/helper';

export interface IMuracaatState {
  tabMuracaatValue: string;
  openRndDialog: boolean;
  activeRow: VwHastamuracaatDTO;
  iptalGosterme: boolean;
  sadeceBorcuOlan: boolean;
  gridFilterModel?: IGridFilterModel;
  gridSortModel?: IGridSortModel;
  request: ApiRequest<VwHastamuracaatListeDTO>;
  selectedMuracaat?: VwHbsHastaservisDTO;
  muracaatBaseRow?: VwMuracaatAramaDTO;
  openMuracaatDetay?: boolean;
  loading?: boolean;
  openYatisTalep: boolean;
  atanmisKurumlar: Array<number>;
  openDepoTalep: boolean;
  detayliArama?: MuracaatDetayliAramaRequest;
  muracaatListe?: VwHastamuracaatListeDTO;
}

const MuracaatSlice = createSlice<
  IMuracaatState,
  MapReducerPayloads<
    IMuracaatState,
    {
      setState: IMuracaatState;
      setActiveRow: VwHastamuracaatDTO;
      setSelectedMuracaat: VwHbsHastaservisDTO;
      setMuracaatBaseRow: VwMuracaatAramaDTO;
      setOpenMuracaatDetay: boolean;
      setLoading: boolean;
      setAtanmisKurumlar: Array<number>;
      setOpenDepoTalep: boolean;
      setDetayliArama?: MuracaatDetayliAramaRequest;
      setMuracaatListe: VwHastamuracaatListeDTO;
    }
  >
>({
  name: 'muracaat',
  initialState: {
    tabMuracaatValue: '0',
    openRndDialog: false,
    activeRow: new VwHastamuracaatDTO(),
    iptalGosterme: true,
    sadeceBorcuOlan: false,
    request: null,
    selectedMuracaat: new VwHbsHastaservisDTO(),
    muracaatBaseRow: new VwMuracaatAramaDTO(),
    openMuracaatDetay: false,
    loading: false,
    openYatisTalep: false,
    atanmisKurumlar: [],
    openDepoTalep: false,
    detayliArama: {
      ...new MuracaatDetayliAramaRequest(),
      baslangicTarih: helper.datetimeToday(),
      bitisTarih: helper.datetimeTodayAddDay(1)
    },
    muracaatListe: new VwHastamuracaatListeDTO(),
  },
  reducers: {
    setState: (state, action) => action.payload,
    setActiveRow: (state, action) => {
      state.activeRow = action.payload;
    },
    setSelectedMuracaat: (state, action) => {
      state.selectedMuracaat = action.payload;
    },
    setMuracaatBaseRow: (state, action) => {
      state.muracaatBaseRow = action.payload;
    },
    setOpenMuracaatDetay: (state, action) => {
      state.openMuracaatDetay = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAtanmisKurumlar: (state, action) => {
      state.atanmisKurumlar = action.payload;
    },
    setOpenDepoTalep: (state, action) => {
      state.openDepoTalep = action.payload;
    },
    setDetayliArama: (state, action) => {
      state.detayliArama = action.payload
    },
    setMuracaatListe: (state, action) => {
      state.muracaatListe = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      MuracaatApi.endpoints.getVwHastamuracaatById.matchFulfilled,
      (state, action) => {
        state.activeRow = {
          ...state.activeRow,
          ...action.payload
        };
        state.loading = true;
      }
    );
  }
});
export default MuracaatSlice;
